var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5946 0.343384C9.57997 0.440987 9.56298 0.540728 9.54406 0.643219C8.89146 4.10652 6.65865 5.30296 3.80707 5.30296H2.35513C2.00637 5.30296 1.71243 5.56461 1.6582 5.92019L0.704273 12.1743C0.668953 12.4078 0.843039 12.6181 1.07092 12.6181H3.64614C3.95101 12.6181 4.21007 12.3892 4.2581 12.0783L4.28337 11.9432L4.76824 8.7629L4.79942 8.58846C4.84686 8.27656 5.10651 8.04745 5.41138 8.04745H5.7965C8.29147 8.04745 10.2447 7.00055 10.8156 3.97073C11.0539 2.7051 10.9305 1.64827 10.2995 0.905021C10.1086 0.680946 9.87169 0.494905 9.5946 0.343384Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFill);
export default __webpack_public_path__ + "static/media/Fill.8a148bab052057e086796fce3243eb3c.svg";
export { ForwardRef as ReactComponent };